import { head } from 'lodash';
import { Keyable } from '@model/common';
import { formatAmpersand } from '@util/format-amp';

export const getTitle = (items: Array<string>, placeholder: string, t: any, options?: Keyable) => {
  const MAX_DESTINATIONS: number = 1;
  if (Array.isArray(items) && items.length) {
    const { custom } = options || {};
    const first = head(items);
    if (first && custom && custom[first]) {
      return custom[first];
    }
    const label: string = items.slice(0, MAX_DESTINATIONS).join(', ');
    const decodedLabel = formatAmpersand(label);

    if (items.length > MAX_DESTINATIONS) {
      const excess: number = items.length - MAX_DESTINATIONS;
      return `${decodedLabel} + ${excess} ${t('common__more')}`;
    }
    return decodedLabel;
  }
  return t(placeholder, options);
};
